<div fxLayout="column" style="padding:15px;">

    <mat-card>
        <mat-card-title>
            <app-page-header [title]="pageTitle" action=''></app-page-header>
        </mat-card-title>
        <mat-card-content fxLayout="column">

            <div fxLayout="column" fxFlex="grow" fxLayoutAlign="center center center" style="margin-top:50px;">

                <div fxLayout="row" fxLayoutGap="20px" fxFlex="grow" ngStyle.md="width:90%" ngStyle.lt-md="width:100%"
                     ngStyle.gt-md="width:90%" fxLayoutAlign="start center">
                    <div fxFlexAlign="center">Αναζήτηση Ημερομηνίας</div>
                    <mat-form-field>
                        <mat-label>
                            Αναζήτηση
                        </mat-label>
                        <input matInput [matDatepicker]="picker" readonly [(ngModel)]="searchDate">
                        <mat-hint>DD/MM/YYYY</mat-hint>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
<!--                        <input matInput (keydown)="search($event.target.value)" placeholder="π.χ 24-04-2022">-->
                    </mat-form-field>

                    <button mat-icon-button (click)="search()">
                        <mat-icon >search</mat-icon>
                    </button>

                    <!--      -->
                </div>


                <div fxLayout="row" fxFlex="grow" style="margin-top:20px;" ngStyle.md="width:90%" ngStyle.lt-md="width:100%"
                     ngStyle.gt-md="width:90%">


                    <div fxLayout="column" fxFlex="grow" #tableContainer>
                        <!--        Table     -->
                        <mat-table  [dataSource]="dataSource" matSort style="width:100%;">


                            <ng-container matColumnDef="firstName">
                                <mat-header-cell  fxFlex="15" *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Όνομα παραλήπτη
                                </mat-header-cell>
                                <mat-cell fxFlex="15"  *matCellDef="let record"
                                          fxLayoutAlign="start center center"> {{record.firstName}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="lastName">
                                <mat-header-cell fxFlex="15"  *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Επώνυμο παραλήπτη
                                </mat-header-cell>
                                <mat-cell  fxFlex="15" *matCellDef="let record"
                                           fxLayoutAlign="start center center"> {{record.lastName}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="telephone">
                                <mat-header-cell fxFlex="20"  *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Τηλέφωνο
                                </mat-header-cell>
                                <mat-cell fxFlex="20" *matCellDef="let record"
                                          fxLayoutAlign="start center center"> {{record.telephone}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="message">
                                <mat-header-cell fxFlex="20"  *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Μήνυμα
                                </mat-header-cell>
                                <mat-cell fxFlex="20" *matCellDef="let record"
                                          fxLayoutAlign="start center center"> {{record.message}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="success">
                                <mat-header-cell fxFlex="20" *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Επιτυχημένη αποστολή
                                </mat-header-cell>
                                <mat-cell fxFlex="20" *matCellDef="let record"
                                          fxLayoutAlign="start center center"> {{record.success ? 'ΝΑΙ' : 'ΟΧΙ'}} </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="action_date">
                                <mat-header-cell fxFlex="20" *matHeaderCellDef mat-sort-header fxLayoutAlign="start center center">
                                    Ημ. αποστολής
                                </mat-header-cell>
                                <mat-cell fxFlex="20" *matCellDef="let record"
                                          fxLayoutAlign="start center center"> {{record.action_date}} </mat-cell>
                            </ng-container>


                            <mat-header-row  *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
                            <mat-row  *matRowDef="let record; columns: columnsToDisplay"></mat-row>
                        </mat-table>

                        <div *ngIf="dataSource.data.length === 0" fxLayoutAlign="center center center" style="margin-top:50px; margin-bottom: 50px;">
                            Δεν υπάρχουν εγγραφές
                        </div>
                    </div>
                </div>
                <div *ngIf="isLoading" fxLayout="row" fxLayoutAlign="end center center" style="margin-top:5px;">
                    <app-loading></app-loading>
                </div>
                <div fxLayout="row" fxLayoutAlign="end center center" style="margin-top:5px;">
                    <mat-paginator [length]="dataSource.data.length" [pageSize]="10" [pageSizeOptions]="[10,20, 50, 100, 200, 400]">
                    </mat-paginator>
                </div>
                <!--        -->

            </div>

        </mat-card-content>
    </mat-card>

</div>
